const mediaItems = [
  {
    id: 1,
    title: '某顶流艺人私密视频曝光，工作室连夜发声明澄清',
    views: '128.6万',
    duration: '03:25',
    category: '明星八卦',
    time: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20entertainment%20video%20thumbnail%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20tones%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20abstract%20entertainment%20visual&width=640&height=360&seq=media-1-51hl&orientation=landscape',
  },
  {
    id: 2,
    title: '综艺录制现场突发意外，嘉宾反应引全网热议',
    views: '96.3万',
    duration: '05:12',
    category: '综艺吃瓜',
    time: '5小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20studio%20emergency%20drama%20visual%20with%20stark%20lighting%20contrast%2C%20dark%20background%20with%20warm%20highlights%2C%20tense%20atmosphere%2C%20entertainment%20production%2C%20no%20people%2C%20no%20text&width=640&height=360&seq=media-2-51hl&orientation=landscape',
  },
  {
    id: 3,
    title: '当红小花被拍到深夜密会，男方身份引猜测',
    views: '215.8万',
    duration: '02:48',
    category: '恋情曝光',
    time: '8小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20night%20scene%20paparazzi%20style%20visual%20with%20dark%20mysterious%20mood%2C%20warm%20street%20light%20glow%2C%20celebrity%20gossip%20aesthetic%2C%20no%20people%2C%20no%20text&width=640&height=360&seq=media-3-51hl&orientation=landscape',
  },
  {
    id: 4,
    title: '某品牌代言人翻车事件全回顾，真相令人意外',
    views: '187.2万',
    duration: '06:35',
    category: '深度吃瓜',
    time: '12小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20brand%20scandal%20investigation%20visual%20with%20dramatic%20shadow%20and%20light%20play%2C%20dark%20atmosphere%20with%20warm%20amber%20reveal%20moments%2C%20mysterious%20corporate%20aesthetic%2C%20no%20people%2C%20no%20text&width=640&height=360&seq=media-4-51hl&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            最新最热的黑料视频与吃瓜视频，高清流畅播放不卡顿
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-1 rounded-md">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-accent-100 text-accent-800 px-2 py-0.5 rounded-md font-medium">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}